import { useContext, useState } from "react";
import { forgetPassword } from "../api/FetchAPI";
import { showAlert } from "../promptMessages/PromptMessages";
import { ALERTMSG } from "../lib/enums";
import { AuthContext } from "../components/AuthContextComponent";
import { SecurityQuestionRequestArray } from "../lib/interfaces";
import useUserLogin from "./UserLoginhook";
import { handleHttpError } from "../lib/helpers/HanldeHttpError";

const useInboxNotification = () => {
  const notifications = [
    {
      id: 1,
      title: "SaaS Design Rework",
      message:
        "Hey John, we’ve reviewed your design updates. Looking really clean! Let’s talk about the navigation...",
      time: "22 min ago",
      sender: "Alice",
    },
    {
      id: 2,
      title: "Fitness App Proposal",
      message:
        "We’re building a cross-platform fitness app and would love to collaborate with you on design and UX.",
      time: "1 hr ago",
      sender: "Brian",
    },
    {
      id: 3,
      title: "Invoice Reminder",
      message:
        "This is a friendly reminder that your invoice #1203 is due by the end of the week.",
      time: "2 hrs ago",
      sender: "Finance Team",
    },
    {
      id: 4,
      title: "New Project Kickoff",
      message:
        "The team kickoff meeting is scheduled for Monday 10AM. Zoom link will be sent later today.",
      time: "Yesterday",
      sender: "Project Manager",
    },
  ];

  const { username, userInfo } = useContext(AuthContext);
  const { customColor } = useUserLogin();

  const [selectedId, setSelectedId] = useState(notifications[0].id);
  const [redirectModal, setRedirectModal] = useState(false);
  const [currentQuestions, setCurrentQuestions] =
    useState<SecurityQuestionRequestArray | null>(null);

  const themeBackground = userInfo?.theme === "DARK" ? "#24292e" : "";
  const themeTextColor = userInfo?.theme === "DARK" ? "#fafbfc" : "";

  const fetchCurrentUserQuestion = async () => {
    try {
      const response: any = await forgetPassword(username);
      const { respCode, respMsg, questionInfo } = response;

      if (respCode === 2000) {
        if (questionInfo === null || questionInfo < 2) {
          setCurrentQuestions(null);
          setRedirectModal(true);
        } else {
          setRedirectModal(false);
          setCurrentQuestions(questionInfo);
        }
      } else {
        showAlert(
          ALERTMSG.SOMEWENTWRONG,
          `${respMsg} (${respCode})`,
          "error",
          customColor,
          themeBackground,
          themeTextColor
        );
      }
    } catch (error) {
      // showAlert(
      //   ALERTMSG.SOMEWENTWRONG,
      //   `An unexpected error occurred.`,
      //   "error",
      //   customColor,
      //   themeBackground,
      //   themeTextColor
      // );
      handleHttpError(error, customColor);
    }
  };

  const selected = notifications.find((n) => n.id === selectedId)!;

  return {
    notifications,
    selected,
    selectedId,
    setSelectedId,
    currentQuestions,
    redirectModal,
    fetchCurrentUserQuestion,
  };
};

export default useInboxNotification;
